import apiClient from '../apiClient';
import { GET_AIRPORT_BY_CITY_URL } from '../apiUrl';

const getAirportByCityApi = id => {
  return apiClient.get(GET_AIRPORT_BY_CITY_URL(id));
};

export default getAirportByCityApi;
